module.exports = "/images/parking-pink.svg?877f9ae4994bf63c41794ac1716a2993";